"use client"
import { Globe } from 'lucide-react';
import { COUNTRIES } from '@/lib/nationality';

interface NationalitySelectProps {
    value: string;
    onChange: (value: string) => void;
    id?: string;
    required?: boolean;
    className?: string;
}

/** Country/nationality dropdown used in the booking and visit-scheduling flows. */
export function NationalitySelect({ value, onChange, id = "nationality", required, className = "" }: NationalitySelectProps) {
    return (
        <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none">
                <Globe size={18} />
            </div>
            <select
                id={id}
                name="nationality"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                required={required}
                className={`w-full pl-11 pr-9 py-3 rounded-xl bg-muted/50 border border-border text-foreground appearance-none cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all ${value ? '' : 'text-muted-foreground'} ${className}`}
            >
                <option value="">Select nationality</option>
                {COUNTRIES.map((c) => (
                    <option key={c} value={c}>{c}</option>
                ))}
            </select>
            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m6 9 6 6 6-6" /></svg>
            </div>
        </div>
    );
}
